<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-face-agent" icon-small title="لیست طرف حساب ها" color="accent">
			<div cols="12" class="pa-5 pt-0">
				<v-row>
					<v-col cols="12" md="6">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12">
						<v-data-table dense :headers="headers" :loading="loading" :items="contacts" :footer-props="{'items-per-page-options': [5, 15, 50, 100]}" :items-per-page="50" :search="search" class="elevation-1">
							<template v-slot:item.fullName="{item}">
								<a href="javascript:void(0)" @click="edit(item)" class="info--text">{{ item.fullName }}</a>
							</template>
							<template v-slot:item.businessName="{item}">
								{{ item.businessName }}
							</template>
							<template v-slot:item.phone="{item}">
								<div>{{ item.phone }}</div>
							</template>
							<template v-slot:item.totalShare="{item}">
								<div @click="loansList(item)" class="info--text text-center" style="cursor: pointer;">{{ item.totalShare.toString().toPriceFormat() }}</div>
								<div class="grey--text d-flex">تعداد وام: <span @click="loansList(item)" class="info--text pr-1" style="cursor: pointer;">{{ item.loanCount }}</span></div>
							</template>
							<template v-slot:item.totalReceives="{item}">
								<div @click="transactionList(item)" class="info--text" style="cursor: pointer;">{{ item.totalReceives.toString().toPriceFormat() }}</div>
							</template>
							<template v-slot:item.address="{item}">
								{{ (item.totalShare - item.totalReceives).toString().toPriceFormat() }}
							</template>
							<template v-slot:item.operations="{item}">
								<div class="text-center">
									<v-btn class="mx-1" fab dark small color="secondary" @click="edit(item)">
										<v-icon dark>
											mdi-square-edit-outline
										</v-icon>
									</v-btn>
									<v-btn class="mx-1" fab dark small color="pink" @click="remove(item)">
										<v-icon dark>
											mdi-trash-can-outline
										</v-icon>
									</v-btn>
								</div>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</div>
			<v-dialog v-model="dialogContact" scrollable persistent max-width="700px">
				<v-card>
					<v-card-title>
						<span class="headline">مشخصات طرف حساب</span>
						<v-spacer />
						<v-btn @click="dialogContact = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<ModifyContact :data="selectedContact" v-if="dialogContact" @callbck="callbck" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogLoansList" scrollable max-width="1200px">
				<v-card>
					<v-card-title>
						<div><span class="headline">لیست پرونده های وام {{ selectedContact.businessName }}</span></div>
						<v-spacer />
						<v-btn @click="dialogLoansList = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<UserLoans v-if="dialogLoansList" :data="{member:selectedContact}" :contact="selectedContact" @update="loadData" />
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogContactTransactionsList" scrollable max-width="1200px">
				<v-card>
					<v-card-title>
						<div><span class="headline">لیست واریز ها به {{ selectedContact.businessName }}</span></div>
						<v-spacer />
						<v-btn @click="dialogContactTransactionsList = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<ContactTransactions v-if="dialogContactTransactionsList" :contact="selectedContact" @update="loadData" />
					</v-card-text>
				</v-card>
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'MembersView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			ModifyContact: () => import('@/views/admin/contact/ModifyContact'),
			UserLoans: () => import('./ContactUserLoans.vue'),
			ContactTransactions: () => import('./ContactTransactions.vue'),
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				errorMessages: '',
				datePickerValidatioin: '',
				localData: {},
				selectedContact: {},
				dialogContact: false,
				dialogLoansList: false,
				dialogContactTransactionsList: false,
				search: '',
				loading: false,
				headers: [
					{
						text: 'نام طرف حساب',
						align: 'start',
						sortable: true,
						value: 'fullName',
						width: 125
					}, {
						text: 'نام تجاری',
						align: 'center',
						sortable: true,
						value: 'businessName',
						width: 175
					}, {
						text: 'شماره تماس',
						align: 'center',
						sortable: true,
						value: 'phone',
					}, {
						text: 'سهم',
						align: 'center',
						sortable: true,
						value: 'totalShare',
						width: 120
					}, {
						text: 'تسویه شده',
						align: 'center',
						sortable: true,
						value: 'totalReceives',
					}, {
						text: 'مانده تسویه نشده',
						align: 'center',
						sortable: true,
						value: 'address',
					}, {
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						value: 'operations',
						width: 135,
					},
				],
				contacts: [],
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/contact/list/true', null)
					.then(
						response => {
							this.contacts = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			add() {
				this.selectedContact = { id: 0 }
				this.dialogContact = true
			},
			edit(item) {
				this.selectedContact = item
				this.dialogContact = true
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/contact/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			callbck(result) {
				this.dialogContact = false
				if (result)
					this.loadData(true)
			},
			loansList(item) {
				this.selectedContact = item
				this.dialogLoansList = true
			},
			transactionList(item) {
				this.selectedContact = item
				this.dialogContactTransactionsList = true
			}

		},
	}
</script>
<style>
</style>
